import axios from "../../axiosConfig/axios";
import { useQuery, useMutation } from "react-query";

const getRfi = async (rfqId, token, status = null, rfiId = null) => {
    let url = ''
    if (rfqId) {
        url = `rfi?rfqId=${rfqId}`
    } else if (rfiId) {
        url = `rfi?rfiId=${rfiId}&detailed=true`
    }
    else {
        url = `rfi?detailed=true`
    }
    if (status) url += `&status=${status}`
    const { data } = await axios.get(url, {
        headers: {
            Authorization: token
        }
    })
    return data
}
export default {
    useRFI(rfqId, token, status) {
        return useQuery(["rfis", rfqId, token, status], () => getRfi(rfqId, token, status), { staleTime: 10000 })
    },
    useSingleRFI(rfiId, token) {
        return useQuery(["rfi", rfiId, token], () => getRfi(null, token, null, rfiId), { staleTime: 10000 })
    },
    async acceptRfi(data) {
        console.log(data)
        var payload = {}
        var supplier = {}
        if (data?.userTyepe == "distributor") {
            payload['missingFields'] = data?.missingFields
        }
        else {
            if (data?.status == 'rejected') {
                supplier['status'] = data?.status
                supplier['rejectionReason'] = data?.reason
            }
            else {
                supplier['status'] = data?.status
                payload['productDetails'] = data?.productDetails
            }
        }

        return axios.patch(`rfi?rfiId=${data?.rfiId}`,
            data?.userTyepe == "distributor" ?
                {
                    ...payload
                } :
                {
                    supplier,
                    ...payload
                },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data?.token
                }
            })

    }
}